import { Box, Skeleton } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

type TabsSkeletonProps = {
  tabsCount: number
}

export const TabsSkeleton = ({ tabsCount }: TabsSkeletonProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Box width="100%" aria-hidden="true">
      <Box
        sx={ {
          alignItems: "flex-end",
          borderBottom: `1.34px solid ${theme.customColors.border}`,
          display: "flex",
          gap: "24px",
          paddingTop: "12px"
        } }
      >
        { Array.from({ length: tabsCount }).map((_, idx) => (
          <Skeleton
            key={ `tabs-skeleton-tab-${idx}` }
            animation="wave"
            height={ "3rem" }
            variant="rounded"
            width={ "8rem" }
          />
        )) }
      </Box>
      <Box
        sx={ {
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          padding: isMobile ? "1.5rem 0 0" : "2.5rem 0 0"
        } }
      >
        <Skeleton animation="wave" height={ "8rem" } variant="rounded" width="100%" />
        <Skeleton animation="wave" height={ "15rem" } variant="rounded" width="100%" />
      </Box>
    </Box>
  );
};
